// extracted by mini-css-extract-plugin
export var container = "CtaCard-module--container--1Cxyj";
export var containerHover = "CtaCard-module--containerHover--cC5ES";
export var copy = "CtaCard-module--copy--QAzf9";
export var header = "CtaCard-module--header--Y6T09";
export var image = "CtaCard-module--image--FlcFW";
export var link = "CtaCard-module--link--mGoh3";
export var linkContainer = "CtaCard-module--linkContainer--6hjrz";